<template>
  <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisible" width="30%">
    <el-row type="flex" justify="center">
      <el-col :span="24">
        <el-card shadow="always">
          <el-tabs v-model="activeName">
            <el-tab-pane :label="$t('passwd.label.resetPass')" name="first">
              <el-form :model="form" v-bind="propbind.form">
                <template >
                  <el-form-item prop="oldPasswd" :label="$t('passwd.label.oldPasswd')">
                    <el-input
                      v-model="form.oldPasswd"
                      type="password"
                      :placeholder="$t('passwd.placeholder.oldPasswd')"
                    />
                  </el-form-item>
                  <el-form-item prop="newPasswd" :label="$t('passwd.label.newPasswd')">
                    <el-input
                      v-model="form.newPasswd"
                      type="password"
                      :placeholder="$t('passwd.placeholder.newPasswd')"
                    />
                  </el-form-item>
                  <el-form-item prop="reNewPasswd" :label="$t('passwd.label.reNewPasswd')">
                    <el-input
                      v-model="form.reNewPasswd"
                      type="password"
                      :placeholder="$t('passwd.placeholder.reNewPasswd')"
                    />
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" @click="updatePasswd">
                      {{ $t('btns.confirm') }}
                    </el-button>
                  </el-form-item>
                </template>
              </el-form>
            </el-tab-pane>
            <!-- /* --------------------------- 修改密码这里是管理员的话就只有登录密码,修改为任何用户都只有重置登陆密码功能 -------------------------- */ -->
            <el-tab-pane
              :label="$t('passwd.label.resetPay')"
              name="second"
              v-if="false"
              style="height: 300px"
            >
              <el-button @click="resetpassword">{{ $t('passwd.label.resetPay') }}</el-button>
            </el-tab-pane>
          </el-tabs>
        </el-card>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
import passwdApi from '@/api/passwd';
import { checkPass,checkPassWd,checkNewPass } from '@/utils/validate';
import { mapActions, mapState } from 'vuex';
export default {
  props: ['value'],
  data() {
    return {
      dialogVisible: false,
      active: 0,
      activeName: 'first',

      form: {
        code: '',
        oldPasswd: '',
        newPasswd: '',
        reNewPasswd: ''
      },

      merchantData: {}
    };
  },
  computed: {
    ...mapState({
      info: ({ user }) => user.info
    })
  },
  watch: {
    value(n) {
      this.dialogVisible = n;
    },
    dialogVisible(n) {
      this.$emit('input', n);
    }
  },
  created() {
    this.init();
  },
  mounted() {
    this.getmerchantNo().then((res) => {
      if (this.$store.state.user.merchantData.googleAuthStatus === 0) {
        this.$router.push({ name: 'safeCenter' });
        return;
      }
    });
  },
  methods: {
    ...mapActions(['getmerchantNo']),
    init() {
      this.propbind = {
        form: {
          ref: 'form',
          rules: {
            code: {
              required: true,
              message: this.$t('merchantdetails.codenull'),
              trigger: 'blur'
            },
            oldPasswd: [
              {
                required: true,
                message: this.$t('passwd.rules.oldPasswd.required'),
                trigger: 'blur'
              },
            ],
            newPasswd: [
              {
                required: true,
                message: this.$t('passwd.rules.newPasswd.required'),
                trigger: 'blur'
              },
              {
                validator: (rules, value, cb) => {
                  if (!checkNewPass(value)) {
                    cb(new Error(this.$t('passwd.rules.newPasswd.format')));
                  } else {
                    cb();
                  }
                },
                trigger: 'blur'
              }
            ],
            reNewPasswd: [
              {
                required: true,
                message: this.$t('passwd.rules.reNewPasswd.required'),
                trigger: 'blur'
              },
              {
                validator: (rules, value, cb) => {
                  if (!checkNewPass(value)) {
                    cb(new Error(this.$t('passwd.rules.newPasswd.format')));
                  } else if (value !== this.form.newPasswd) {
                    cb(new Error(this.$t('passwd.rules.reNewPasswd.same')));
                  } else {
                    cb();
                  }
                },
                trigger: 'blur'
              }
            ]
          }
        }
      };
    },


    goBack() {
      this.$router.back();
    },
    handleEmpty() {
      this.form = {
        code: '',
        oldPasswd: '',
        newPasswd: '',
        reNewPasswd: ''
      };
    },
    updatePasswd() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const params = {
            id: this.info.id,
            newPassword: this.form.newPasswd,
            oldPassword: this.form.oldPasswd
          };
          const { data } = await passwdApi.updatePasswd(params);
          if (data) {
            if (data.code === 200) {
              this.$message.success(this.$t('status.success'));
              this.dialogVisible = false;
              this.handleEmpty();
              this.$store.dispatch('loginOut');
              // this.$router.push({ name: 'login' });
            } else {
              this.$message.error(data.msg);
            }
          }
        }
      });
    },
    async resetpassword() {
      // 弹框询问用户是否重置密码
      const confirmResult = await this.$confirm(
        this.$t('accountmanager.hintmessage'),
        this.$t('btns.hint'),
        {
          confirmButtonText: this.$t('btns.confirm'),
          cancelButtonText: this.$t('btns.cancel'),
          type: 'warning'
        }
      ).catch((err) => err);
      // 用户确认删除 返回值为字符串 confirm
      // 用户取消删除 返回值为字符串 cancel
      if (confirmResult !== 'confirm') {
        return this.$message.info(this.$t('btns.cancel'));
      }
      const { data } = await passwdApi.resetPay({ merchantId: this.info.userName });
      if (data && data.code !== 200) {
        return this.$message.error(this.$t('btns.error'));
      }
      this.$router.push({ name: 'home' });
      this.$message.success(this.$t('btns.success'));
    }
  }
};
</script>

<style lang="scss" scoped>
.login-wrap {
  background-color: #324152;
  height: 100%;
}

 .el-tab-pane {
  min-height: 500px;
}
</style>



// WEBPACK FOOTER //
// src/components/cuscom/passwd/index.vue